/**
 * Optional body fields for generate-* APIs (Content-Disposition LV segment).
 */
export function buildLvNumberPayload({ summary, pdfSummary, initialProperty, lvTrim }) {
  const raw = summary?.lvCislo ?? pdfSummary?.lvCislo ?? initialProperty?.cislo_lv ?? lvTrim;
  if (raw == null || String(raw).trim() === '') return {};
  const digits = String(raw).replace(/\D/g, '');
  return digits ? { lvNumber: digits } : {};
}
